import store from '../../../global-state/redux';
import { navigate } from '../../../global-utils/vmFunctions/navigate';
import { replaceHref } from '../../../global-utils/vmFunctions/windowLocation';

const { getState } = store;

export const navigateIfHoldingPageIsDeactivate = (path, isInternal) => {
  const isActive = getState()?.appState?.settings?.modules?.holdingPage?.isActive;
  if (!isActive && isInternal) navigate(path);
  if (!isActive && !isInternal) replaceHref(path);
};
